export enum CustomErrorsCode {
  // 10300 warning, 10400 error client
  INDEXDB_UPGRADE_NEEDED = "10300",
  CLIENT_ERROR = "10400",
}
